"use client"

import { useState, type ReactNode } from "react"

import { Button } from "./Button"
import { ProjetoDialog } from "./ProjetoDialog"
import { useProjetoAtivo } from "@/lib/projeto-planejamento/context"

type RequireProjetoProps = {
  children: ReactNode
}

/**
 * Envolve pages Projeto-scope (/budget, /strategy, /reports). Quando
 * `projetoAtivo === null`, oculta o conteudo e renderiza um empty state
 * com CTA para abrir o ProjetoDialog. Nao re-direciona — o usuario
 * cria o projeto in-place e a UI rehidrata via Provider + revalidatePath
 * disparado pelo Server Action.
 */
export function RequireProjeto({ children }: RequireProjetoProps) {
  const { projetoAtivo } = useProjetoAtivo()
  const [dialogOpen, setDialogOpen] = useState(false)

  if (projetoAtivo) {
    return <>{children}</>
  }

  return (
    <>
      <div
        role="region"
        aria-label="Sem projeto ativo"
        className="mx-auto flex max-w-xl flex-col items-center gap-4 rounded border border-markv-surface-200 bg-markv-surface-50 px-6 py-10 text-center"
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          className="h-10 w-10 text-markv-primary-accent"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
        </svg>
        <h2 className="text-lg font-semibold text-markv-text-700">
          Crie seu primeiro projeto de planejamento
        </h2>
        <p className="text-sm text-markv-text-500">
          Budget, Strategy e Reports trabalham sempre dentro de um projeto.
          Defina o nome e o intervalo de anos para começar.
        </p>
        <Button onClick={() => setDialogOpen(true)}>Novo projeto</Button>
      </div>
      <ProjetoDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  )
}
